import { createRoute } from '@/utils/routing'

export const FOREX_SETUP_RATES_ROUTE = 'forex-setup-index-rates'
export const FOREX_SETUP_LIMITS_ROUTE = 'forex-setup-index-limits'
export const FOREX_REQUEST_LIST_ROUTE = 'forex-requests'

export function createForexSetupRatesRoute (options = {}) {
  return createRoute(FOREX_SETUP_RATES_ROUTE, options)
}

export function createForexSetupLimitsRoute (options = {}) {
  return createRoute(FOREX_SETUP_LIMITS_ROUTE, options)
}

export function createForexRequestListRoute (options = {}) {
  return createRoute(FOREX_REQUEST_LIST_ROUTE, options)
}
